module.exports = __webpack_public_path__ + "img/0Q3A3001_L_BlackMatted.edf48d7a.jpg";